module.exports = __webpack_public_path__ + "models/smoke_detector_875f52965ce70ab4998a73c0e0d4e81d.glb";